<template>
    <nav class="navbar">
        <div class="custom-container">
            <div class="row">
                <div class="col-lg-12 d-flex">
                    <img src="/img/logo.svg" class="logo">
                    <div class="align-self-center ms-auto">
                        <span class="bg-success color-white px-3 py-2 rounded sub bold">Vraag {{ currentQuestion }} / 18</span>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
    name:  'NavigationReceiver',
    props: ['currentQuestion']
}
</script>
